<template>
  <div class=" is-fullwidth">
    <div class="  ">
        <div class="columns ">
          <div class="column">
            <div class="buttons">
              <button class="button" :class="{'is-success' : tabToView == 'new'}" @click="tabToView='new'" v-if="user.user_ireland==1">New Orders</button>
              <button class="button" :class="{'is-success' : tabToView == 'inprogress'}" @click="tabToView='inprogress'" v-if="user.user_ireland==1">In Progress</button>
              <button class="button" :class="{'is-success' : tabToView == 'knitcomplete'}" @click="tabToView='knitcomplete'" v-if="user.user_ireland==1">Knit Complete (Ready For Despatch)</button>
              <button class="button" :class="{'is-success' : tabToView == 'intransit'}" @click="tabToView='intransit'">In Transit</button>
              <button class="button" :class="{'is-success' : tabToView == 'complete'}"  @click="tabToView='complete'">Complete/Received</button>
            </div>
          </div>
          <div class="column is-one-fifth">
            <button class="button is-light">{{filteredOrders.length}} orders / {{ this.totalGarments}} garments</button>
          </div>
          <div class="column is-one-fifth">
        <input class="input " v-model="search" placeholder="search orders ..."/>
          </div>
          
           
          </div>
          <br />
    </div>
   
    <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable">
    	<thead>
    		<th width="60">&nbsp;</th>
        <th>PO Number</th>
   	 		<th>Customer</th>
          <th>Garment</th>
          <th>Design Name</th>
          <th @click="updateSortOrder('orderdate')" style="cursor:pointer">Ordered
            <span v-if="order_by === 'orderdate DESC'">&#8595;</span>
            <span v-if="order_by === 'orderdate ASC'">&#8593;</span>
          </th>
          <th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Delivery
            <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
            <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
          </th>
          <th>Qty</th>
          <th>Makeup</th>
          <th v-if="tabToView=='new' || tabToView=='inprogress' || tabToView=='knitcomplete'">Process</th>
          <th v-if="tabToView=='intransit' || tabToView=='complete'">Type</th>
          <th v-if="tabToView=='intransit' || tabToView=='complete'">Despatch</th>
          <th v-if="tabToView=='intransit' ">Receive</th>
          
    	</thead>
    	<tbody>
		    <tr v-if="loading === true">
                <td colspan="11" ><div class="notification is-info">Loading orders ...</div></td>
            </tr>
            <tr v-if="loading == false && filteredOrders.length == 0">
                <td colspan="11" ><div class="notification is-warning">There are no orders to show</div></td>
            </tr>
            
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
         <td >
                  <a :href="ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-small is-info" :disabled="working===true" >Print</button></a>
              </td>
               <td ><a :href="'/orders/order-search?ponumber=' + order.ponumber" target="_blank">{{order.ponumber}}</a></td>
          <td>{{order.clientname}}</td>
          <td>{{order.garmentname}}</td>
          <td>{{order.designname}}</td>
          <td>{{order.orderdate}}</td> 
          <td>{{order.deliverydate}}</td>
          <td>{{ order.total_qty }}</td>
          <td>
            <span v-if="order.ireland==1">Ireland / {{ order.makeup_location_name }}</span>
            <span v-if="order.offshore==1">Offshore / {{  order.makeup_location_name }}</span>
          </td>

          <!-- New orders view-->
          <td v-if="tabToView=='new'" >
            <div class="buttons">
              <button class="button is-small " v-if="(order.knit_in_progress==0 || order.knit_in_progress == null) && user.user_ireland == 1" @click="setInProgress(order, 'knit')" :disabled="working==true">To Be Knit</button>
              <button class="button is-small " v-if="(order.knit_in_progress==0 || order.knit_in_progress == null) && user.user_ireland == 1" @click="setInProgress(order, 'stock')" :disabled="working==true">From Stock</button>
            </div>
          </td>
          <!-- In Progress orders-->
          <td v-if="tabToView=='inprogress'" >
            <div class="buttons">
              <button class="button is-small " v-if="(order.knit_complete==0 ) && user.user_ireland == 1" @click="completeKnit(order)" :disabled="working==true">Complete Knit</button>
              
            </div>
          </td>

          <!-- Completed Knit orders-->
          <td v-if="tabToView=='knitcomplete'" >
            <div class="buttons">
              <button class="button is-small " v-if="(order.knit_complete==1 && order.knit_despatched==0 && order.knit_complete_type != 'stock') && user.user_ireland == 1" @click="despatch(order)" :disabled="working==true">Despatch</button>
              
            </div>
          </td>

          <!-- In Transit orders-->
          <td v-if="tabToView=='intransit' || tabToView=='complete'" >
            {{  capitalize(order.knit_complete_type) }}
          </td>
          <td v-if="tabToView=='intransit' || tabToView=='complete'" >
            <span v-if="order.knit_complete_type == 'knit'">{{  capitalize(order.knit_despatched_location) }} / {{  capitalize(order.knit_despatched_method) }}</span>
          </td>
          <td v-if="tabToView=='intransit'" >
            <div class="buttons">
              <button class="button is-small " v-if="(order.knitted_trim_complete==0 )" @click="receiveKnittedTrim(order)" :disabled="working==true">Received Order</button>
              
            </div>
          </td>

              
			</tr>
    	</tbody>
    </table>

    <p>
      <button @click="exportXLS()" class="button is-info" :disabled="loading==true">Export to Excel</button>
    </p>


    <div class="modal " v-bind:class="{ 'is-active' : showDespatchModal} ">
      <div class="modal-background"></div>
      <div class="modal-card process">
        <header class="modal-card-head">
          <p class="modal-card-title">Process Order</p>
          <button class="delete" aria-label="close" @click="showDespatchModal=false"></button>
        </header>
        <section class="modal-card-body p-6">
          <div class="">

            <p>Makeup location 
              <strong><span v-if="selectedOrder.ireland == 1">Ireland</span>
              <span v-if="selectedOrder.offshore == 1">Offshore</span>
              /
              {{  selectedOrder.makeup_location_name }}</strong>
            </p>
            <br />
              
            <div v-if="this.selectedOrder.knit_despatched == 1">
              <p >This order has already been despatched</p>
              <p>Location : {{  selectedOrder.knit_despatched_location }}</p>
              <p>Method : {{  selectedOrder.knit_despatched_method }}</p>
            </div>
            

               <form class="form" @submit.prevent="despatchOrder()" v-else>
               
                <div class="field">
            <label class="label">Despatch Location</label>
            <div class="control">
              <div class="select">
                <select required v-model="knit_despatched_location">
                  <option value="">Please select ....</option>
                  <option value="unit1">Unit 1</option>
                  <option value="offshore">Offshore</option>
                </select>
              </div>
            </div>
          </div>
          <div class="field">
            <label class="label">Method</label>
            <div class="control">
              <div class="select">
                <select required v-model="knit_despatched_method">
                  <option value="">Please select ....</option>
                  <option value="local_truck">Local Truck</option>
                  <option value="hand_delivery">Hand Delivery</option>
                  <option value="offshore_truck">Offshore Truck</option>
                  <option value="offshore_courier">Offshore Courier</option>
                </select>
              </div>
            </div>
          </div>
          <div class="field is-grouped">
            <div class="control">
              <button class="button is-success"  >Despatch Order</button>
            </div>
            
          </div>


                
              </form>
              </div>
            
            
        </section>
        
      </div>
    </div>

    
    
    
  </div>
</template>

<script>
import XLSX from 'xlsx';

import OrderService from '@/services/OrderService.js';
//import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
    
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showDespatchModal: false,
      selectedOrder: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      ranges: [],
      makeuplocations: [],
      order_by: 'deliverydate ASC',
      makeup_location_id: '',
      showAddButtons: true,
      accessToken: '',
      showKnitModal: false,
      knit_complete_type: '',
      knit_despatched_location: '',
      knit_despatched_method: '',
      search:'',
      user: {tasks: []},
      tabToView: 'new',
      
    }
  },
   methods: {
    parseUKDate(dateString) {
      const [day, month, year] = dateString.split('/');
      return new Date(year, month - 1, day);
    },
    locationDisplay(ireland, offshore)
    {
      if(ireland == 1)
      {
        return "Ireland"
      }
       if(offshore == 1)
      {
        return "Offshore"
      }
      else { return ""}
    },  
    exportXLS() {
      //var wb = XLSX.utils.table_to_book(document.getElementById('orderstable'), {sheet:"Sheet JS"});
      //XLSX.writeFile(wb, 'Cutting Report.xlsx')

      const filteredData = this.filteredOrders.map(order => ({
        "PO Number": order.ponumber,
        "Customer": order.clientname,
        "Garment": order.garmentname,
        "Design Name": order.designname,
        "Order Date": this.parseUKDate(order.orderdate),
        "Delivery Date": this.parseUKDate(order.deliverydate),
        "Qty": order.total_qty,
        "Makeup Area": this.locationDisplay(order.ireland, order.offshore),
        "Makeup Location" : order.makeup_location_name,
        "Type": order.knit_complete_type,
        "Despatch Location": order.knit_despatched_location,
        "Despatch Method" : order.knit_despatched_method
       
        // exclude fields you don't want
      }));
      

      const ws = XLSX.utils.json_to_sheet(filteredData);

      // Apply date format to column C (example)
      

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Orders");

      XLSX.writeFile(wb, "Knitted Trims Export.xlsx");

    },
    capitalize(str) {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
     
    despatch(order)
    {
      this.selectedOrder = order
      this.showDespatchModal = true
    },
    complete(order)
    {
      this.selectedOrder = order
      this.showKnitModal = true
    },
    despatchOrder()
    {
      this.working = true

        var formdata = { 
             order_id: this.selectedOrder.orderID,
             knit_despatched: 1,
             knit_despatched_method: this.knit_despatched_method,
             knit_despatched_location: this.knit_despatched_location
        }; 

        OrderService.updateKnittedTrim(this.accessToken, formdata)
        .then(() => {
            this.selectedOrder.knit_despatched = 1
            this.selectedOrder.knit_despatched_method = this.knit_despatched_method
            this.selectedOrder.knit_despatched_location = this.knit_despatched_location
            this.working = false
            this.showDespatchModal = false
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    completeKnit(order)
    {
      this.working = true

        var formdata = { 
             order_id: order.orderID,
             knit_complete: 1,
             
        }; 

        OrderService.updateKnittedTrim(this.accessToken, formdata)
        .then(() => {
            order.knit_complete = 1
            
            this.working = false
           //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
      
    },
    setInProgress(order, knit_type)
    {
      this.working = true

        var formdata = { 
             order_id: order.orderID,
             knit_in_progress: 1,
             knit_complete_type: knit_type
        }; 

        OrderService.updateKnittedTrim(this.accessToken, formdata)
        .then(() => {
            order.knit_in_progress = 1
            order.knit_complete_type = knit_type
            this.working = false
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
      
    },
      async getOrders() {
        this.loading=true
        this.orders = []
        OrderService.getKnittedTrimOrders(this.accessToken, this.order_by)
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
      async receiveKnittedTrim(order) {
        this.working = true

        if(order.knitted_trim_complete == 1)
        {
            this.working = false
            return false
        }
        else
        {
          if(confirm("Are you sure you want to mark this order as Knitted Trims received ?"))
          {
            var order_id = order.orderID

              var formdata = { 
                  _method: 'patch',
                  knitted_trim_complete : 1
                  
              }; 

              OrderService.updateOrder(this.accessToken, order_id, formdata)
              .then(() => {
                  order.knitted_trim_complete = 1
                  this.working = false
                  //console.log(response)
              }).catch((error) => {
                alert("Something went wrong and the order has not been updated. Please reload and try again")
                  console.log("Error:" + JSON.stringify(error.response.data));
                  this.working = false
              });
          }
          else{
            this.working = false
            return false
          }
          
        }
      },
      
      
    
   
    
  },
  computed : {
      filteredOrders: function () {
        // let filteredOrders = []
          //let filteredOrders = this.orders
          let filteredOrders =  this.orders

            if(this.search != '' && this.search != null)
            {
              filteredOrders = filteredOrders.filter(row => row.ponumber.toLowerCase().includes(this.search.toLowerCase()) || row.garmentname.toLowerCase().includes(this.search.toLowerCase()) || row.clientname.toLowerCase().includes(this.search.toLowerCase()))
            }

            if(this.tabToView != '' && this.tabToView != null)
            {
              if(this.tabToView == "new")
              {
                filteredOrders = filteredOrders.filter(row => row.knit_in_progress == 0 || row.knit_in_progress == null )
              }
              else if(this.tabToView == "inprogress")
              {
                filteredOrders = filteredOrders.filter(row => row.knit_in_progress == 1 && row.knit_complete_type == 'knit' && row.knit_complete == 0)
              }
              else if(this.tabToView == "knitcomplete")
              {
                filteredOrders = filteredOrders.filter(row => row.knit_complete == 1 && row.knit_complete_type == 'knit' && row.knit_despatched == 0)
              }
              else if(this.tabToView == "intransit")
              {
                filteredOrders = filteredOrders.filter(row => row.knit_complete == 1 && ( (row.knit_complete_type=='stock') || (row.knit_complete_type=='knit' && row.knit_despatched==1) ) && row.knitted_trim_complete == 0)
              }
              else if(this.tabToView == "complete")
              {
                filteredOrders = filteredOrders.filter(row =>  row.knitted_trim_complete == 1)
              }
            }

            return filteredOrders
        
      },
      totalGarments() {
        return this.filteredOrders.reduce((sum, order) => sum + (order.total_qty || 0), 0);
      }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           this.getUserProfile();
        });
  },
 
  mounted() {
    /*if (localStorage.production_allocated_makeup_location_id) {
      this.makeup_location_id = localStorage.production_allocated_makeup_location_id;
    }
    else{
      this.makeup_location_id = 5
    }*/
      
  },
  watch: {
   tabToView: function () {
      if(this.tabToView == "new")
      {
        this.getOrders()
      }
    },
  
    user: function () {
        if(this.tabToView == "new" && this.user.user_ireland == 0)
        {
          this.tabToView = 'intransit'
        }
      },
    },
}


</script>

